module.exports = __webpack_public_path__ + "static/kopparlundens-c342a5a4a7cd98a1452c20d13c15da28.svg";